import { importAllAsyncRoutes, publicRoutes } from '@/router/index'

export default {
  namespaced: true,
  state: {
    // 路由表
    routes: []
  },
  mutations: {
    /** 增加路由 */
    setRoutes(state, newRoutes) {
      // 永远在静态路由的基础上增加新路由
      state.routes = [...publicRoutes, ...newRoutes]
    }
  },
  actions: {
    /** 根据权限筛选路由 */
    filterRoutes(context, menus) {
      const routes = []
      const asyncRoutes = importAllAsyncRoutes()
      asyncRoutes.forEach((item) => {
        // console.log('item:', item)
        // if (menus.find((key) => item.name === key)) {
        routes.push(item)
        // }
        // routes.push(
        //   ...menus.filter((key) => {
        //     return item.name === key
        //   })
        // ...asyncRoutes.filter((item) => {
        //   return item.name
        // })
        // )
        // routes.push(...asyncRoutes)
      })

      // 最后添加 不匹配进入404
      routes.push({
        path: '/:catchAll(.*)'
      })
      context.commit('setRoutes', routes)
      return routes
    }
  }
}
